import React, { useCallback, useEffect, useRef, useState } from 'react';
import moment from 'moment-timezone';

import { HexColorPicker } from "react-colorful";
import AutosizeInput from 'react-input-autosize';
import { useDropzone } from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import { profesionalStartDelete, startNewProfesional, startSaveProfesional, startUploading, unactiveProfesional } from '../../../actions/profesionales';
import { openModal, openModalBottom } from '../../../actions/ui';

import { ArrowBackIcon, AvatarIcon, ConfigIcon, DescansosIcon, HorarioIcon, ServiciosIcon, TrashIcon, TimeIcon, ControlHorarioIcon } from '../../../assets/svg/iconos';
import { Rating } from '../../../components/tools/Rating';
import { newProfesional } from '../../../helpers/helpers';
import useClickOutside from '../../../hooks/useClickOutside';
import { DelaySelect } from './DelaySelect';
import { DelaySelectValue } from './DelaySelectValue';
import { Descansos } from './Descansos';
import { Horario } from './Horario';
import { ModalEliminarProfesional } from './modales/ModalEliminarProfesional';
import { ModalAvisoSmsProfesional } from './modales/ModalAvisoSmsProfesional';
import { Permisos } from './Permisos';
import { Servicios } from './Servicios';
import { ControlHorarios } from './ControlHorarios';
import { fetchConToken, fetchSinToken } from '../../../helpers/fetch';
import { getHorariosOcupados, testHorarios } from '../../../helpers/horarios';
import { YlmModalTwoButtons } from '../../../components/main/YlmModalTwoButtons';

const timezone = process.env.REACT_APP_TIMEZONE;

export const Profesional = ({ history }) => {
    const dispatch = useDispatch();
    const { empresa: empresaAuth, profesional: authProfesional, role: authRole } = useSelector(state => state.auth);
    const empresa = typeof empresaAuth === 'string' ? empresaAuth : empresaAuth?._id;
    const { colores, miniLateral } = useSelector(state => state.ui);
    const { sucursales } = useSelector(state => state.sucursales);
    const { active: profActive, profesionales } = useSelector(state => state.profesionales);
    const [profSaved, setProfSaved] = useState(true);

    const [activeTab, setActiveTab] = useState(history.location.state.activeTab || 'horarios');

    const [currentProfesional, setCurrentProfesional] = useState(history.location.state.profesional || null);

    const [currentScreen, setCurrentScreen] = useState((history.location.state.profesional) ? 'edit' : 'new');

    const [imageUrl, setImageUrl] = useState('');
    const [file, setFile] = useState(null);
    const [profImage, setProfImage] = useState(null);

    const [objProfesional, setObjProfesional] = useState({});
    const [iniciado, setIniciado] = useState(false);
    const [cambiado, setCambiado] = useState(false);
    const [cambiadoVacaciones, setCambiadoVacaciones] = useState(false);
    const [hasUsuarioValido, setHasUsuarioValido] = useState(false);

    const [editMode, setEditMode] = useState(true);

    const [ratingValue, setRatingValue] = useState(history.location.state?.profesional?.valoracion || '5');

    const popover = useRef();
    const [isOpen, toggle] = useState(false);

    const [addSucursalValue, setAddSucursalValue] = useState({});
    const [horasOcupadas, setHorasOcupadas] = useState([
        { diasSemana: '1', horas: [] },
        { diasSemana: '2', horas: [] },
        { diasSemana: '3', horas: [] },
        { diasSemana: '4', horas: [] },
        { diasSemana: '5', horas: [] },
        { diasSemana: '6', horas: [] },
        { diasSemana: '7', horas: [] }
    ]);

    const [descansosObj, setDescansosObj] = useState([]);
    const [descansosTemp, setDescansosTemp] = useState([]);

    const [horariosExtraObj, setHorariosExtraObj] = useState([]);
    const previousUsuarioRef = useRef(null);
    const [horariosExtraTemp, setHorariosExtraTemp] = useState([]);
    const [cambiadoHorariosExtra, setCambiadoHorariosExtra] = useState(false);

    const [dataModal, setDataModal] = useState({
        title: '¿Cambiar plan?',
        text: ['¿Está seguro de que desea actualizar al plan?'],
        buttonText: 'Estoy seguro',
        button2Text: 'Cancelar'
    });
    const [modalTwoButtonsOpened, setModalTwoButtonsOpened] = useState(false);
    const [modalPeriodoResponse, setModalPeriodoResponse] = useState(100);
    const [modalPeriodoWaiting, setModalPeriodoWaiting] = useState({});

    const [modalEliminarProfesionalOpened, setModalEliminarProfesionalOpened] = useState(false);
    const [modalAvisoSmsOpened, setModalAvisoSmsOpened] = useState(false);
    const [dataModalEliminar, setDataModalEliminar] = useState({
        title: '¿Eliminar profesional?',
        text: [],
        buttonText: 'Eliminar',
        button2Text: 'Cancelar'
    });

    const close = useCallback(() => toggle(false), []);
    useClickOutside(popover, close);

    const getImage = useCallback(
        async () => {
            const nombre = currentProfesional.img[0];
            
            if (nombre && nombre.startsWith('http')) {
                setImageUrl({ url: nombre });
                return;
            }
            
            if (!nombre || nombre === 'null' || nombre === null) {
                const baseUrl = process.env.REACT_APP_API_URL;
                const defaultUrl = `${baseUrl}/images/professionals/uploads/default-profesional.jpg`;
                setImageUrl({ url: defaultUrl });
                return;
            }
            
            const baseUrl = process.env.REACT_APP_API_URL;
            const directUrl = `${baseUrl}/images/professionals/uploads/${nombre}`;
            setImageUrl({ url: directUrl });
        },
        [currentProfesional]
    )

    useEffect(() => {
        if (currentScreen !== "new")
            setCurrentProfesional(profesionales.find(p => p._id === history.location.state.profesional?._id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profesionales, history])

    useEffect(() => {
        return () => {
            if (!profSaved) {
                alert('Salimos?');
            }
            dispatch(unactiveProfesional());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (currentProfesional) {
            setObjProfesional(currentProfesional);
            setIniciado(true);
            if (currentProfesional._id) {
                if (currentProfesional.img.length > 0) {
                    getImage();
                }
            }
        } else {
            setEditMode(true);
            setCambiado(true);
            const nuevo = newProfesional(empresa);
            setCurrentProfesional(nuevo);
            setObjProfesional(nuevo);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentProfesional]);

    useEffect(() => {
        const checkUsuarioValido = async () => {
            const tieneId = objProfesional?._id && typeof objProfesional._id === 'string' && objProfesional._id.length > 0;
            const tieneUsuario = objProfesional?.usuario != null && 
                                 typeof objProfesional.usuario === 'string' && 
                                 objProfesional.usuario.length > 0 &&
                                 objProfesional.usuario !== objProfesional._id;
            
            if (tieneId && tieneUsuario) {
                try {
                    const resp = await fetchConToken(`usuarios/usuario`, 
                        { usuario: objProfesional.usuario, empresa }, 
                        'POST'
                    );
                    const body = await resp.json();
                    
                    if (body.ok && body.usuario) {
                        setHasUsuarioValido(true);
                    } else {
                        setHasUsuarioValido(false);
                    }
                } catch (error) {
                    console.error('Error verificando usuario:', error);
                    setHasUsuarioValido(false);
                }
            } else {
                setHasUsuarioValido(false);
            }
        };

        if (objProfesional?._id) {
            checkUsuarioValido();
        } else {
            setHasUsuarioValido(false);
        }
    }, [objProfesional?._id, objProfesional?.usuario, empresa]);

    const horariosOcupados = async (prof) => {
        const newHorasOcupadas = await getHorariosOcupados(prof, sucursales);
        setHorasOcupadas(newHorasOcupadas);
    };


    useEffect(() => {
        if (currentProfesional) {
            const profesionalOriginal = { ...currentProfesional };
            if (iniciado) {
                let igual = true;
                for (const propiedad in profesionalOriginal) {
                    if (profesionalOriginal[propiedad] !== objProfesional[propiedad]) {
                        igual = false;
                    }
                }
                setCambiado(!igual);
            }
        }
        if (profImage) {
            setCambiado(true);
        }

    }, [iniciado, currentProfesional, objProfesional, profImage]);

    useEffect(() => {
        if (objProfesional._id && objProfesional._id !== 'undefined' && objProfesional._id !== 'null') {
            horariosOcupados(objProfesional);
            getVacacionesProfesional();
            getHorariosExtraProfesional();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [objProfesional]);

    useEffect(() => {
        if (modalPeriodoWaiting._id) {
            if (modalPeriodoResponse === 1) {
                if (modalPeriodoWaiting.type === 'horarioExtra') {
                    deleteHorarioExtraFromDB(modalPeriodoWaiting._id);
                } else {
                    deleteVacacionesFromDB(modalPeriodoWaiting._id);
                }
            }
            setModalPeriodoWaiting({});
            setModalPeriodoResponse(100);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalPeriodoResponse]);

    const getVacacionesProfesional = async () => {
        try {
            const resp = await fetchConToken('vacaciones/profesional', { empresa, profesional: objProfesional._id }, 'POST');
            const body = await resp.json();
            
            let vacaciones = body.vacaciones || [];
            
            if (body.ok) {
                setDescansosObj(vacaciones);
                setDescansosTemp(vacaciones);
            } else if (vacaciones.length > 0) {
                console.warn('Respuesta no OK pero se encontraron vacaciones:', body);
                setDescansosObj(vacaciones);
                setDescansosTemp(vacaciones);
            } else if (descansosObj.length > 0) {
                console.warn('Error al cargar vacaciones, manteniendo las existentes:', body);
            } else {
                setDescansosObj([]);
                setDescansosTemp([]);
            }
        } catch (error) {
            console.error('Error crítico al cargar vacaciones:', error);
            if (descansosObj.length > 0) {
                console.warn('Error al cargar, manteniendo vacaciones existentes');
            } else {
                setDescansosObj([]);
                setDescansosTemp([]);
            }
        }
    }

    const getHorariosExtraProfesional = async () => {
        try {
            const profesionalUsuarioId = objProfesional.usuario || objProfesional._id;
            const resp = await fetchSinToken('horarios-extra/profesional', { empresa, profesional: profesionalUsuarioId }, 'POST');
            const body = await resp.json();
            
            let horariosExtra = body.horariosExtra || [];
            const idsExistentes = new Set(horariosExtra.map(he => he._id));
            
            if (objProfesional.usuario && objProfesional.usuario !== objProfesional._id) {
                try {
                    const respById = await fetchSinToken('horarios-extra/profesional', { empresa, profesional: objProfesional._id }, 'POST');
                    const bodyById = await respById.json();
                    if (bodyById.ok && bodyById.horariosExtra) {
                        const horariosPorId = bodyById.horariosExtra || [];
                        const horariosUnicos = horariosPorId.filter(he => !idsExistentes.has(he._id));
                        horariosExtra = [...horariosExtra, ...horariosUnicos];
                        horariosUnicos.forEach(he => idsExistentes.add(he._id));
                    }
                } catch (errorById) {
                    console.error('Error al buscar horarios extra por _id:', errorById);
                }
            }
            
            if (!objProfesional.usuario && previousUsuarioRef.current && previousUsuarioRef.current !== objProfesional._id) {
                try {
                    const respByPreviousUsuario = await fetchSinToken('horarios-extra/profesional', { empresa, profesional: previousUsuarioRef.current }, 'POST');
                    const bodyByPreviousUsuario = await respByPreviousUsuario.json();
                    if (bodyByPreviousUsuario.ok && bodyByPreviousUsuario.horariosExtra) {
                        const horariosPorUsuarioAnterior = bodyByPreviousUsuario.horariosExtra || [];
                        const horariosUnicos = horariosPorUsuarioAnterior.filter(he => !idsExistentes.has(he._id));
                        horariosExtra = [...horariosExtra, ...horariosUnicos];
                    }
                } catch (errorByPreviousUsuario) {
                    console.error('Error al buscar horarios extra por usuario anterior:', errorByPreviousUsuario);
                }
            }
            
            if (body.ok) {
                setHorariosExtraObj(horariosExtra);
                setHorariosExtraTemp(horariosExtra);
            } else if (horariosExtra.length > 0) {
                console.warn('Respuesta no OK pero se encontraron horarios extra:', body);
                setHorariosExtraObj(horariosExtra);
                setHorariosExtraTemp(horariosExtra);
            } else if (horariosExtraObj.length > 0) {
                console.warn('Error al cargar horarios extra, manteniendo los existentes:', body);
            } else {
                setHorariosExtraObj([]);
                setHorariosExtraTemp([]);
            }
        } catch (error) {
            console.error('Error crítico al cargar horarios extra:', error);
            if (horariosExtraObj.length > 0) {
                console.warn('Error al cargar, manteniendo horarios extra existentes');
            } else {
                setHorariosExtraObj([]);
                setHorariosExtraTemp([]);
            }
        }
    }

    const compareObjs = () => {
        let igual = true;
        
        if (descansosObj.length !== descansosTemp.length) { 
            igual = false; 
        } else {
            const hayNuevos = descansosTemp.some(d => d._id && d._id.substring(0, 3) === 'new');
            if (hayNuevos) {
                igual = false;
            } else {
                descansosTemp.forEach((descanso) => {
                    if (descanso._id && descanso._id.substring(0, 3) !== 'new') {
                        const itemOriginal = descansosObj.find(d => d._id === descanso._id);
                        if (itemOriginal) {
                            const propiedadesImportantes = ['fechaInicio', 'fechaFin', 'diasSemana', 'tipo'];
                            for (const propiedad of propiedadesImportantes) {
                                if (Array.isArray(itemOriginal[propiedad]) && Array.isArray(descanso[propiedad])) {
                                    if (JSON.stringify(itemOriginal[propiedad].sort()) !== JSON.stringify(descanso[propiedad].sort())) {
                                        igual = false;
                                        return;
                                    }
                                } else if (itemOriginal[propiedad] !== descanso[propiedad]) {
                                    igual = false;
                                    return;
                                }
                            }
                        } else {
                            igual = false;
                        }
                    }
                });
            }
        }
        setCambiadoVacaciones(!igual);
    };

    const compareHorariosExtra = () => {
        let igual = true;
        
        if (horariosExtraObj.length !== horariosExtraTemp.length) { 
            igual = false; 
        } else {
            const hayNuevos = horariosExtraTemp.some(he => he._id && he._id.substring(0, 3) === 'new');
            if (hayNuevos) {
                igual = false;
            } else {
                horariosExtraTemp.forEach((horarioExtra) => {
                    if (horarioExtra._id && horarioExtra._id.substring(0, 3) !== 'new') {
                        const itemOriginal = horariosExtraObj.find(h => h._id === horarioExtra._id);
                        if (itemOriginal) {
                            for (const propiedad in itemOriginal) {
                                if (Array.isArray(itemOriginal[propiedad]) && Array.isArray(horarioExtra[propiedad])) {
                                    if (JSON.stringify(itemOriginal[propiedad].sort()) !== JSON.stringify(horarioExtra[propiedad].sort())) {
                                        igual = false;
                                        return;
                                    }
                                } else if (itemOriginal[propiedad] !== horarioExtra[propiedad]) {
                                    igual = false;
                                    return;
                                }
                            }
                        } else {
                            igual = false;
                        }
                    }
                });
            }
        }
        setCambiadoHorariosExtra(!igual);
    };

    useEffect(() => {
        compareObjs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descansosTemp]);

    useEffect(() => {
        compareHorariosExtra();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [horariosExtraTemp]);

    const backClick = () => {
        history.goBack();
    }

    const changeTab = (tabName) => {
        if (objProfesional._id) {
            setActiveTab(tabName);
        } else {
            const datos = {
                text: ['Para añadir más datos, debes crear primero el profesional'],
                timeOut: 3
            }
            dispatch(openModalBottom(datos));
        }
    };

    const onFormChange = (e) => {
        dataChange(e.target.name, e.target.value);
    }

    const dataChange = (name, value) => {
        setObjProfesional({
            ...objProfesional,
            [name]: value
        });
    }

    const hayCambiosSinGuardar = cambiado || cambiadoVacaciones || cambiadoHorariosExtra;
    const esUsuarioProfesional = authRole === 'PROFESSIONAL_ROLE';
    const puedeAvisarPorSms = currentScreen === 'edit' && Boolean(objProfesional?._id) && !hayCambiosSinGuardar && !esUsuarioProfesional;

    const deleteProfesionalModal = () => {
        setDataModalEliminar({
            ...dataModalEliminar,
            text: [`¿Estás seguro de que deseas eliminar a ${objProfesional.nombre}?`]
        })
        setModalEliminarProfesionalOpened(true);
    };

    const deleteProfesionalResponse = (value) => {
        if (value === 1) {
            let selectedId = objProfesional._id;
            if (!selectedId) {
                if (profActive._id) {
                    selectedId = profActive._id;
                    dispatch(profesionalStartDelete(selectedId, empresa));
                    history.push({ pathname: `/profesionales` })
                }
            } else {
                dispatch(profesionalStartDelete(selectedId, empresa));
                history.push({ pathname: `/profesionales` })
            }
        }
    }

    const clickPicker = () => {
        if (editMode) {
            toggle(true);
        } else {
            dispatch(openModalBottom({ text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3 }));
        }
    }

    const setColor = (color) => {
        if (iniciado) { dataChange('color', color); }
    }

    const changeValoracion = (value) => {
        if (editMode) {
            setRatingValue(value);
        } else {
            dispatch(openModalBottom({ text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3 }));
        }
    }

    const setDelay = (type, value) => {
        if (iniciado) {
            setObjProfesional({
                ...objProfesional,
                delayType: type,
                delay: value
            });
        }
    }

    const addSucursal = (sucursal) => {
        if (editMode) {
            const newSucursales = [
                ...objProfesional.sucursales,
                sucursal._id
            ]

            const newHorarioSucursales = [
                ...objProfesional.horarioSucursales,
                {
                    sucursal: sucursal._id,
                    horarios: [
                        { diasSemana: "1", horas: [] },
                        { diasSemana: "2", horas: [] },
                        { diasSemana: "3", horas: [] },
                        { diasSemana: "4", horas: [] },
                        { diasSemana: "5", horas: [] },
                        { diasSemana: "6", horas: [] },
                        { diasSemana: "7", horas: [] },
                    ],
                    horarioTxt: '',
                    prioridad: '1000000'
                }
            ]

            setObjProfesional({
                ...objProfesional,
                sucursales: newSucursales,
                horarioSucursales: newHorarioSucursales
            })
        } else {
            dispatch(openModalBottom({ text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3 }));
        }
    };

    const deleteSucursal = (e, sucursal) => {
        e.stopPropagation();
        if (editMode) {
            const newSucursales = objProfesional.sucursales.filter(item => (item !== sucursal));
            const newHorarioSucursales = objProfesional.horarioSucursales.filter(horarioSuc => {
                let respuesta = true;
                const idHorarioSuc = horarioSuc.sucursal._id ? horarioSuc.sucursal._id : horarioSuc.sucursal;
                if (sucursal === idHorarioSuc) {
                    respuesta = false;
                }
                return respuesta;
            })

            setObjProfesional({
                ...objProfesional,
                sucursales: newSucursales,
                horarioSucursales: newHorarioSucursales
            })
        } else {
            dispatch(openModalBottom({ text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3 }));
        }
    };

    const guardar = async () => {
        setEditMode(true);
        // 
        let newProfesional = {
            ...objProfesional
        };
        if (profImage) {
            let previa = '';
            if (currentProfesional.img.length > 0) {
                previa = currentProfesional.img[0];
            }
            const imgName = `${currentProfesional._id}-${new Date().getTime()}`;
            const archivo = file;
            const nombreCortado = archivo.name.split('.');
            const extension = nombreCortado[nombreCortado.length - 1];
            const nombreCompleto = `${imgName}.${extension}`;

            newProfesional = { ...newProfesional, img: [nombreCompleto] };

            dispatch(startUploading(file, newProfesional, nombreCompleto, previa));
        }

        const sinCoincidencias = testHorarios(horasOcupadas);

        if (cambiado) {
            if (sinCoincidencias) {
                if (currentScreen === 'edit') {
                    dispatch(startSaveProfesional(newProfesional));
                    setCambiado(false);
                }
                if (currentScreen === 'new') {
                    const id = await dispatch(startNewProfesional(newProfesional));

                    if (id) {
                        const newProfesionalSaved = {
                            ...objProfesional,
                            _id: id
                        };
                        setObjProfesional(newProfesionalSaved)

                        history.replace({
                            pathname: `/profesional/${id}`, state: {
                                activeTab,
                                profesional: newProfesionalSaved
                            }
                        });

                        setCurrentScreen("edit");
                    }
                }
            } else {
                dispatch(openModal({
                    title: 'Error en los horarios',
                    text: ['Este profesional tiene franjas horarias que se repiten en diferentes locales durante el mismo día.', 'Por favor, revise los horarios.'],
                    buttonText: 'Aceptar'
                }))
            }
        }

        if (cambiadoVacaciones) {
            const resultado = await compruebaVacaciones();
            if (resultado) {
                setCambiadoVacaciones(false);
            }
        }

        if (cambiadoHorariosExtra) {
            const resultado = await compruebaHorariosExtra();
            if (resultado) {
                setCambiadoHorariosExtra(false);
            }
        }
    }

    const cancelar = () => {
        if (currentScreen !== 'new') {
            if (cambiadoVacaciones) {
                resetVacaciones();
            }
            if (cambiadoHorariosExtra) {
                resetHorariosExtra();
            }
            if (cambiado) {
                setEditMode(true);
                setProfImage(null);
                setFile(null);
                setObjProfesional(currentProfesional);
            }
        } else {
            history.goBack();
        }
    }

    const resetVacaciones = () => {
        setDescansosTemp([...descansosObj]);
    }

    const compruebaVacaciones = async () => {
        try {
            for (const desc of descansosTemp) {
                if (desc.repetir && (!desc.diasSemana || desc.diasSemana.length === 0)) {
                    dispatch(openModalBottom({ 
                        text: ['Error: Los descansos con repetición deben tener al menos un día seleccionado'], 
                        timeOut: 5 
                    }));
                    return false;
                }
                
                const esNuevo = !desc._id || (desc._id && desc._id.slice(0, 3) === 'new');
                
                if (esNuevo) {
                    const newDescanso = { ...desc };
                    delete newDescanso._id;
                    try {
                        await newVacaciones(newDescanso);
                    } catch (error) {
                        // No eliminamos la ausencia: la conservamos en la lista para que el usuario
                        // pueda corregirla (p. ej. ajustar las horas) y volver a guardar.
                        dispatch(openModal({
                            title: 'No se pudo guardar la ausencia',
                            text: [error.message || 'Error desconocido', 'Revisa las fechas y horas e inténtalo de nuevo.'],
                            buttonText: 'Aceptar'
                        }));
                        return false;
                    }
                } else if (desc._id) {
                    const itemOriginal = descansosObj.find(d => d._id === desc._id);
                    if (itemOriginal) {
                        const propiedadesImportantes = ['fechaInicio', 'fechaFin', 'diasSemana', 'tipo'];
                        let hayCambios = false;
                        
                        for (const propiedad of propiedadesImportantes) {
                            if (Array.isArray(itemOriginal[propiedad]) && Array.isArray(desc[propiedad])) {
                                if (JSON.stringify(itemOriginal[propiedad].sort()) !== JSON.stringify(desc[propiedad].sort())) {
                                    hayCambios = true;
                                    break;
                                }
                            } else if (itemOriginal[propiedad] !== desc[propiedad]) {
                                hayCambios = true;
                                break;
                            }
                        }
                        
                        if (hayCambios) {
                            try {
                                await saveVacaciones(desc);
                            } catch (error) {
                                dispatch(openModalBottom({ 
                                    text: [`Error al guardar descanso: ${error.message || 'Error desconocido'}`], 
                                    timeOut: 5 
                                }));
                                return false;
                            }
                        }
                    }
                }
            }
            
            await getVacacionesProfesional();
            return true;
        } catch (error) {
            let mensajeError = 'Error al guardar los descansos.';
            if (error.message) {
                mensajeError = `Error: ${error.message}`;
            }
            dispatch(openModalBottom({ 
                text: [mensajeError, 'Por favor, revise los datos e inténtelo de nuevo.'], 
                timeOut: 6 
            }));
            return false;
        }
    }

    const newVacaciones = async (descanso) => {
        try {
            const resp = await fetchConToken(`vacaciones`, { ...descanso }, 'POST');
            const body = await resp.json();
            
            if (!resp.ok || !body.ok) {
                let errorMsg = 'Error al crear el descanso';
                if (body.msg) {
                    errorMsg = body.msg;
                } else if (body.message) {
                    errorMsg = body.message;
                } else if (body.errors) {
                    const errores = Array.isArray(body.errors) 
                        ? body.errors.join(', ') 
                        : JSON.stringify(body.errors);
                    errorMsg = `Errores de validación: ${errores}`;
                } else if (!resp.ok) {
                    errorMsg = `Error HTTP: ${resp.status} ${resp.statusText}`;
                }
                throw new Error(errorMsg);
            }
            
            if (!body.vacaciones || !body.vacaciones._id) {
                throw new Error('El descanso no se guardó correctamente. No se recibió confirmación del servidor.');
            }
            
        } catch (error) {
            throw error;
        }
    };

    const saveVacaciones = async (descanso) => {
        try {
            const resp = await fetchConToken(`vacaciones/${descanso._id}`, { 
                empresa, 
                profesional: objProfesional._id,
                fechaInicio: descanso.fechaInicio, 
                fechaFin: descanso.fechaFin, 
                diasSemana: descanso.diasSemana || [],
                repetir: descanso.repetir || (descanso.diasSemana && descanso.diasSemana.length > 0),
                tipo: descanso.tipo || 'ausencia'
            }, 'PUT');
            
            const body = await resp.json();
            
            if (!resp.ok || !body.ok) {
                let errorMsg = 'Error al guardar el descanso';
                if (body.msg) {
                    errorMsg = body.msg;
                } else if (body.message) {
                    errorMsg = body.message;
                } else if (body.errors) {
                    const errores = Array.isArray(body.errors) 
                        ? body.errors.join(', ') 
                        : JSON.stringify(body.errors);
                    errorMsg = `Errores de validación: ${errores}`;
                } else if (!resp.ok) {
                    errorMsg = `Error HTTP: ${resp.status} ${resp.statusText}`;
                }
                throw new Error(errorMsg);
            }
            
            if (!body.vacaciones || !body.vacaciones._id) {
                throw new Error('El descanso no se actualizó correctamente. No se recibió confirmación del servidor.');
            }
            
        } catch (error) {
            throw error;
        }
    }

    const deleteVacaciones = (descanso) => {
        if (descanso._id.substring(0, 3) !== 'new') {
            setDataModal({
                title: '¿Borrar periodo vacacional?',
                text: [`¿Está seguro de que desea borrar este periodo vacacional?`],
                buttonText: 'Estoy seguro',
                button2Text: 'Cancelar'
            })
            setModalTwoButtonsOpened(true);
            setModalPeriodoWaiting(descanso);
        }
    }

    const deleteVacacionesFromDB = async (id) => {
        try {
            const resp = await fetchConToken(`vacaciones/${id}`, { empresa }, 'DELETE');
            const body = await resp.json();
            if (body.ok) {
                await getVacacionesProfesional();
            }
        } catch (error) {
            console.log(error);
        }
    }

    const resetHorariosExtra = () => {
        setHorariosExtraTemp([...horariosExtraObj]);
    }


    const haySolapamientoHorariosExtra = (horario1, horario2) => {
        if (horario1._id === horario2._id) return false;

        const fechaInicio1 = moment.tz(horario1.fechaInicio, timezone);
        const fechaFin1 = moment.tz(horario1.fechaFin, timezone);
        const fechaInicio2 = moment.tz(horario2.fechaInicio, timezone);
        const fechaFin2 = moment.tz(horario2.fechaFin, timezone);

        const rangosFechasSolapan = fechaInicio1.isSameOrBefore(fechaFin2) && fechaFin1.isSameOrAfter(fechaInicio2);
        if (!rangosFechasSolapan) return false;

        if (horario1.repetir && horario2.repetir) {
            const diasComunes = horario1.diasSemana.filter(dia => horario2.diasSemana.includes(dia));
            if (diasComunes.length === 0) return false;
        } else if (horario1.repetir || horario2.repetir) {
            if (horario1.repetir) {
                const diaSemana2 = moment.tz(horario2.fechaInicio, timezone).isoWeekday().toString();
                if (!horario1.diasSemana.includes(diaSemana2)) return false;
            } else {
                const diaSemana1 = moment.tz(horario1.fechaInicio, timezone).isoWeekday().toString();
                if (!horario2.diasSemana.includes(diaSemana1)) return false;
            }
        }

        if (horario1.todaJornada || horario2.todaJornada) {
            return true;
        }

        const horaInicio1 = horario1.horaInicio ? moment.tz(horario1.horaInicio, timezone) : null;
        const horaFin1 = horario1.horaFin ? moment.tz(horario1.horaFin, timezone) : null;
        const horaInicio2 = horario2.horaInicio ? moment.tz(horario2.horaInicio, timezone) : null;
        const horaFin2 = horario2.horaFin ? moment.tz(horario2.horaFin, timezone) : null;

        if (!horaInicio1 || !horaFin1 || !horaInicio2 || !horaFin2) return true;

        const hora1Inicio = horaInicio1.hours() * 60 + horaInicio1.minutes();
        const hora1Fin = horaFin1.hours() * 60 + horaFin1.minutes();
        const hora2Inicio = horaInicio2.hours() * 60 + horaInicio2.minutes();
        const hora2Fin = horaFin2.hours() * 60 + horaFin2.minutes();

        return (hora1Inicio < hora2Fin && hora1Fin > hora2Inicio);
    };

    const compruebaHorariosExtra = async () => {
        try {
            for (let i = 0; i < horariosExtraTemp.length; i++) {
                const he = horariosExtraTemp[i];
                
                for (let j = i + 1; j < horariosExtraTemp.length; j++) {
                    const he2 = horariosExtraTemp[j];
                    if (haySolapamientoHorariosExtra(he, he2)) {
                        dispatch(openModalBottom({ 
                            text: ['Este horario extra se solapa con otro horario extra. Por favor, revise los horarios.'], 
                            timeOut: 5 
                        }));
                        return false;
                    }
                }

                if (!he.fechaInicio || !he.fechaFin) {
                    dispatch(openModalBottom({ 
                        text: ['Error: El horario extra debe tener fecha de inicio y fin definidas'], 
                        timeOut: 5 
                    }));
                    return false;
                }

                if (!he.horaInicio || !he.horaFin) {
                    dispatch(openModalBottom({ 
                        text: ['Error: El horario extra debe tener hora de inicio y fin definidas'], 
                        timeOut: 5 
                    }));
                    return false;
                }

                if (he.repetir && (!he.diasSemana || he.diasSemana.length === 0)) {
                    dispatch(openModalBottom({ 
                        text: ['Error: Los horarios extra con repetición deben tener al menos un día seleccionado'], 
                        timeOut: 5 
                    }));
                    return false;
                }

                const esNuevo = !he._id || (he._id && he._id.slice(0, 3) === 'new');
                
                if (esNuevo) {
                    const tempId = he._id;
                    const newHorarioExtra = { ...he };
                    delete newHorarioExtra._id;
                    try {
                        await newHorariosExtra(newHorarioExtra);
                    } catch (error) {
                        setHorariosExtraTemp(prev => prev.filter(he => he._id !== tempId));
                        dispatch(openModalBottom({ 
                            text: [`Error al crear horario extra: ${error.message || 'Error desconocido'}`], 
                            timeOut: 5 
                        }));
                        return false;
                    }
                } else if (he._id) {
                    const itemOriginal = horariosExtraObj.find(h => h._id === he._id);
                    if (itemOriginal) {
                        let hayCambios = false;
                        for (const propiedad in itemOriginal) {
                            if (['__v', 'createdAt', 'updatedAt', 'modificationHistory'].includes(propiedad)) {
                                continue;
                            }
                            
                            if (Array.isArray(itemOriginal[propiedad]) && Array.isArray(he[propiedad])) {
                                if (JSON.stringify(itemOriginal[propiedad].sort()) !== JSON.stringify(he[propiedad].sort())) {
                                    hayCambios = true;
                                    break;
                                }
                            } else if (itemOriginal[propiedad] !== he[propiedad]) {
                                hayCambios = true;
                                break;
                            }
                        }
                        if (hayCambios) {
                            try {
                                await saveHorariosExtra(he);
                            } catch (error) {
                                dispatch(openModalBottom({ 
                                    text: [`Error al guardar horario extra: ${error.message || 'Error desconocido'}`], 
                                    timeOut: 5 
                                }));
                                return false;
                            }
                        }
                    } else {
                        console.warn('Horario extra no encontrado en original:', he._id);
                    }
                }
            }
            
            await getHorariosExtraProfesional();
            
            return true;
        } catch (error) {
            
            let mensajeError = 'Error al guardar los horarios extra.';
            
            if (error.message) {
                mensajeError = `Error: ${error.message}`;
            } else if (error.response) {
                mensajeError = `Error del servidor: ${error.response.status} - ${error.response.statusText}`;
            } else if (error.name === 'TypeError' && error.message && error.message.includes('fetch')) {
                mensajeError = 'Error de conexión: No se pudo conectar con el servidor. Verifique su conexión a internet.';
            }
            
            dispatch(openModalBottom({ 
                text: [mensajeError, 'Por favor, revise los datos e inténtelo de nuevo.'], 
                timeOut: 6 
            }));
            return false;
        }
    }

    const newHorariosExtra = async (horarioExtra) => {
        try {
            const profesionalUsuarioId = objProfesional.usuario || objProfesional._id;
            
            const payload = {
                ...horarioExtra,
                empresa: empresa,
                profesional: profesionalUsuarioId
            };
            
            const resp = await fetchConToken(`horarios-extra`, payload, 'POST');
            const body = await resp.json();
            
            if (!resp.ok || !body.ok) {
                let errorMsg = 'Error al crear el horario extra';
                if (body.msg) {
                    errorMsg = body.msg;
                } else if (body.message) {
                    errorMsg = body.message;
                } else if (body.errors) {
                    const errores = Array.isArray(body.errors) 
                        ? body.errors.join(', ') 
                        : JSON.stringify(body.errors);
                    errorMsg = `Errores de validación: ${errores}`;
                } else if (resp.status === 404) {
                    errorMsg = `El endpoint '/api/horarios-extra' no existe en el servidor. Por favor, verifique que la ruta esté configurada correctamente en el backend.`;
                } else if (!resp.ok) {
                    errorMsg = `Error HTTP: ${resp.status} ${resp.statusText}`;
                }
                throw new Error(errorMsg);
            }
            
            if (!body.horarioExtra || !body.horarioExtra._id) {
                throw new Error('El horario no se guardó correctamente. No se recibió confirmación del servidor.');
            }
            
        } catch (error) {
            throw error;
        }
    };

    const saveHorariosExtra = async (horarioExtra) => {
        try {
            const profesionalUsuarioId = objProfesional.usuario || objProfesional._id;
            const payload = {
                empresa: empresa,
                profesional: profesionalUsuarioId,
                fechaInicio: horarioExtra.fechaInicio,
                fechaFin: horarioExtra.fechaFin,
                todaJornada: horarioExtra.todaJornada,
                repetir: horarioExtra.repetir,
                diasSemana: horarioExtra.diasSemana || [],
                horaInicio: horarioExtra.horaInicio,
                horaFin: horarioExtra.horaFin
            };
            
            const resp = await fetchConToken(`horarios-extra/${horarioExtra._id}`, payload, 'PUT');
            const body = await resp.json();
            
            if (!resp.ok || !body.ok) {
                let errorMsg = 'Error al guardar el horario extra';
                if (body.msg) {
                    errorMsg = body.msg;
                } else if (body.message) {
                    errorMsg = body.message;
                } else if (body.errors) {
                    const errores = Array.isArray(body.errors) 
                        ? body.errors.join(', ') 
                        : JSON.stringify(body.errors);
                    errorMsg = `Errores de validación: ${errores}`;
                } else if (resp.status === 404) {
                    errorMsg = `El endpoint '/api/horarios-extra/${horarioExtra._id}' no existe en el servidor. Por favor, verifique que la ruta esté configurada correctamente en el backend.`;
                } else if (!resp.ok) {
                    errorMsg = `Error HTTP: ${resp.status} ${resp.statusText}`;
                }
                throw new Error(errorMsg);
            }
            
            if (!body.horarioExtra || !body.horarioExtra._id) {
                throw new Error('El horario no se actualizó correctamente. No se recibió confirmación del servidor.');
            }
            
        } catch (error) {
            throw error;
        }
    }

    const deleteHorarioExtra = (horarioExtra) => {
        if (horarioExtra._id && horarioExtra._id.substring(0, 3) === 'new') {
            setHorariosExtraTemp(horariosExtraTemp.filter(he => he._id !== horarioExtra._id));
            setCambiadoHorariosExtra(true);
        } else {
            setDataModal({
                title: '¿Borrar horario extra?',
                text: [`¿Está seguro de que desea borrar este horario extra?`],
                buttonText: 'Estoy seguro',
                button2Text: 'Cancelar'
            })
            setModalTwoButtonsOpened(true);
            setModalPeriodoWaiting({...horarioExtra, type: 'horarioExtra'});
        }
    }

    const deleteHorarioExtraFromDB = async (id) => {
        try {
            const resp = await fetchConToken(`horarios-extra/${id}`, { empresa }, 'DELETE');
            const body = await resp.json();
            if (body.ok) {
                await getHorariosExtraProfesional();
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (iniciado) {
            dataChange('valoracion', ratingValue.toString());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ratingValue]);


    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        setFile(file);
        setProfImage(URL.createObjectURL(file));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [objProfesional]);

    const { getRootProps, getInputProps } = useDropzone({
        accept: "image/jpeg, image/png",
        noKeyboard: true,
        onDrop
    });

    return (
        <>
            <div
                className='profesional'
                style={{
                    '--colorPrincipal': colores.colorPrincipal,
                    '--colorSecundario': colores.colorSecundario,
                    '--color3': colores.color3,
                    '--color4': colores.color4,
                    '--color5': colores.color5,
                    '--color6': colores.color6,
                    '--color7': colores.color7,
                }}
            >
                <div className='profesional-wrapper'>
                    <div className='single-profesional'>
                        <div className={`header ${!miniLateral && 'compress'}`}>
                            <div
                                className='nav-back'
                                onClick={backClick}
                            >
                                <ArrowBackIcon color={colores.colorSecundario} />
                                <p style={{ color: colores.colorSecundario }}>Profesionales</p>
                            </div>
                            <div className='botonera'>
                                {
                                    puedeAvisarPorSms &&
                                    <button
                                        className='btn btn-cancelar'
                                        style={{ color: colores.colorPrincipal, backgroundColor: colores.color6 }}
                                        onClick={() => setModalAvisoSmsOpened(true)}
                                    >
                                        Avisar a clientes por SMS
                                    </button>
                                }
                                {
                                    (!cambiado && !cambiadoVacaciones && !cambiadoHorariosExtra) &&
                                    <button
                                        className='btn-mini btn-eliminar'
                                        style={{ backgroundColor: colores.color6 }}
                                        onClick={deleteProfesionalModal}
                                    >
                                        <TrashIcon color={colores.colorPrincipal} />
                                    </button>
                                }
                                {
                                    (cambiado || cambiadoVacaciones || cambiadoHorariosExtra) &&
                                    <button
                                        className='btn btn-crear'
                                        style={{ backgroundColor: colores.colorPrincipal }}
                                        onClick={guardar}
                                    >
                                        {`${currentScreen === 'new' ? 'Crear' : 'Guardar'}`}
                                    </button>
                                }
                                {
                                    (cambiado || cambiadoVacaciones || cambiadoHorariosExtra) &&
                                    <button
                                        className='btn btn-cancelar'
                                        style={{ color: colores.colorPrincipal, backgroundColor: colores.color6 }}
                                        onClick={cancelar}
                                    >
                                        Cancelar
                                    </button>
                                }
                            </div>
                        </div>
                        <div className='profesional-body'>
                            <h1>{`${objProfesional?.nombre ? objProfesional?.nombre : 'Nombre'}`}</h1>
                            <div className='prof-main'
                                style={{
                                    backgroundColor: colores.color6
                                }}>
                                <div className='main-left'>
                                    <div
                                        {...getRootProps({ className: `dropzone avatar` })}
                                        style={{
                                            backgroundImage: `url(${profImage ? profImage : (imageUrl.url || '')})`
                                        }}
                                    >
                                        <input {...getInputProps({ className: `${(!profImage && !imageUrl.url) ? 'no-image' : ''}` })} />
                                        {
                                            (!profImage && !imageUrl.url) &&
                                            <>
                                                <AvatarIcon />
                                                <div className='avatar-bg'>+</div>
                                            </>
                                        }
                                    </div>
                                    <div className='data'>
                                        <div className='name'>
                                            <AutosizeInput
                                                inputStyle={{ backgroundColor: editMode ? '#ffffff' : 'transparent' }}
                                                autoComplete='off'
                                                type="text"
                                                placeholder='Nombre'
                                                name="nombre"
                                                disabled={!editMode}
                                                value={objProfesional.nombre || ''}
                                                onChange={(e) => onFormChange(e)}
                                            />
                                            <div className="picker">
                                                <div
                                                    className="swatch"
                                                    style={{ backgroundColor: objProfesional.color || '#448FF3' }}
                                                    onClick={() => clickPicker()}
                                                />
                                                {isOpen && (
                                                    <div className="popover" ref={popover}>
                                                        <HexColorPicker color={objProfesional.color || '#448FF3'} onChange={setColor} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='rate'>
                                            <Rating
                                                ratingValue={objProfesional.valoracion || '5'}
                                                setRatingValue={(e) => changeValoracion(e)}
                                            />
                                            <div className='rates-number'>
                                                (34 Valoraciones)
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className='col-item delays'>
                                        <DelaySelect
                                            delayType={objProfesional.delayType}
                                            delay={objProfesional.delay}
                                            setDelay={setDelay}
                                            editMode={editMode}
                                        />
                                        <DelaySelectValue
                                            delayType={objProfesional.delayType}
                                            delay={objProfesional.delay}
                                            setDelay={setDelay}
                                            editMode={editMode}
                                        />
                                    </div>
                                    <div
                                        className='col-item'
                                        style={{ backgroundColor: colores.color6 }}
                                    >
                                        <div className='toggle-text'>
                                            <p>Visible en App</p>
                                        </div>
                                        <div
                                            className={`ylm-toggle ${objProfesional.visibleEnApp && 'active'}`}
                                                onClick={() => dataChange('visibleEnApp', !objProfesional.visibleEnApp)}
                                        >
                                            <div
                                                className='toggle-chevron'
                                            >
                                                <div
                                                    className={`toggle-bg`}
                                                    style={{ backgroundColor: objProfesional.visibleEnApp ? '#FFFFFF' : '#C9C5C5' }}
                                                    >
                                                    <span
                                                        className={`toggle-item`}
                                                        style={{ backgroundColor: objProfesional.visibleEnApp ? colores.colorPrincipal : '#7B7B7B' }}
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='prof-tabs'>
                                <div
                                    className={`prof-tab ${activeTab === 'horarios' && 'active'}`}
                                    style={{
                                        backgroundColor: activeTab === 'horarios' ? colores.colorPrincipal : colores.color6,
                                        color: activeTab === 'horarios' ? 'white' : colores.colorPrincipal
                                    }}
                                    onClick={() => changeTab('horarios')}
                                >
                                    <span className='tab-icon'><HorarioIcon color={activeTab === 'horarios' ? 'white' : colores.colorPrincipal} /></span>
                                    <p>Horario y sucursales</p>
                                </div>
                                <div
                                    className={`prof-tab prof-tab-descansos ${activeTab === 'descansos' && 'active'}`}
                                    style={{
                                        backgroundColor: activeTab === 'descansos' ? colores.colorPrincipal : colores.color6,
                                        color: activeTab === 'descansos' ? 'white' : colores.colorPrincipal
                                    }}
                                    onClick={() => changeTab('descansos')}
                                >
                                    <span className='tab-icon'><DescansosIcon color={activeTab === 'descansos' ? 'white' : colores.colorPrincipal} /></span>
                                    <p>Días especiales</p>
                                </div>
                                <div
                                    className={`prof-tab ${activeTab === 'servicios' && 'active'}`}
                                    style={{
                                        backgroundColor: activeTab === 'servicios' ? colores.colorPrincipal : colores.color6,
                                        color: activeTab === 'servicios' ? 'white' : colores.colorPrincipal
                                    }}
                                    onClick={() => changeTab('servicios')}
                                >
                                    <span className='tab-icon'><ServiciosIcon color={activeTab === 'servicios' ? 'white' : colores.colorPrincipal} /></span>
                                    <p>Servicios</p>
                                </div>
                                <div
                                    className={`prof-tab ${activeTab === 'permisos' && 'active'}`}
                                    style={{
                                        backgroundColor: activeTab === 'permisos' ? colores.colorPrincipal : colores.color6,
                                        color: activeTab === 'permisos' ? 'white' : colores.colorPrincipal,
                                        userSelect: 'none',
                                        cursor: "unset",
                                        textDecoration: 'none',
                                        //opacity: "0.6"
                                    }}
                                	onClick={() => changeTab('permisos')}
                                >
                                    <span className='tab-icon'><ConfigIcon color={activeTab === 'permisos' ? 'white' : colores.colorPrincipal} /></span>
                                    <p>Permisos</p>
                                </div>
                                {hasUsuarioValido && !authProfesional && (
                                    <div
                                        className={`prof-tab prof-tab-control-horarios ${activeTab === 'control-horarios' && 'active'}`}
                                        style={{
                                            backgroundColor: activeTab === 'control-horarios' ? colores.colorPrincipal : colores.color6,
                                            color: activeTab === 'control-horarios' ? 'white' : colores.colorPrincipal
                                        }}
                                        onClick={() => changeTab('control-horarios')}
                                    >
                                        <span className='tab-icon'><ControlHorarioIcon color={activeTab === 'control-horarios' ? 'white' : colores.colorPrincipal} /></span>
                                        <p>Control de horarios</p>
                                    </div>
                                )}
                            </div>
                            <div className='prof-secondary'>
                                {
                                    activeTab === 'horarios' &&
                                    <Horario
                                        objProfesional={objProfesional}
                                        setObjProfesional={setObjProfesional}
                                        currentProfesional={currentProfesional}
                                        addSucursalValue={addSucursalValue}
                                        setAddSucursalValue={setAddSucursalValue}
                                        addSucursal={addSucursal}
                                        deleteSucursal={deleteSucursal}
                                        setProfSaved={setProfSaved}
                                        horasOcupadas={horasOcupadas}
                                        setHorasOcupadas={setHorasOcupadas}
                                        editMode={editMode}
                                    />
                                }
                                {
                                    activeTab === 'descansos' &&
                                    <Descansos
                                        objProfesional={objProfesional}
                                        setObjProfesional={setObjProfesional}
                                        descansosObj={descansosObj}
                                        descansosTemp={descansosTemp}
                                        setDescansosTemp={setDescansosTemp}
                                        deleteVacaciones={deleteVacaciones}
                                        editMode={editMode}
                                        horariosExtraTemp={horariosExtraTemp}
                                        setHorariosExtraTemp={setHorariosExtraTemp}
                                        deleteHorarioExtra={deleteHorarioExtra}
                                    />
                                }
                                {
                                    activeTab === 'servicios' &&
                                    <Servicios
                                        objProfesional={objProfesional}
                                        setObjProfesional={setObjProfesional}
                                        editMode={editMode}
                                    />
                                }
                                {
                                    activeTab === 'permisos' &&
                                    <Permisos
                                        objProfesional={objProfesional}
                                        setObjProfesional={setObjProfesional}
                                        editMode={editMode}
                                    />
                                }
                                {
                                    activeTab === 'control-horarios' && !authProfesional && (
                                        hasUsuarioValido ? (
                                            <ControlHorarios
                                                objProfesional={objProfesional}
                                            />
                                        ) : (
                                            <div style={{ 
                                                padding: '40px 20px', 
                                                textAlign: 'center',
                                                color: colores.colorPrincipal,
                                                backgroundColor: colores.color6,
                                                borderRadius: '8px',
                                                margin: '20px'
                                            }}>
                                                <h3 style={{ marginBottom: '15px' }}>Usuario no vinculado</h3>
                                                <p style={{ marginBottom: '10px' }}>Este profesional necesita tener un usuario vinculado para usar el control horario.</p>
                                                <p>Por favor, ve a la pestaña <strong>"Permisos"</strong> y crea un usuario para este profesional.</p>
                                            </div>
                                        )
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalEliminarProfesional
                data={dataModalEliminar}
                setModalResponse={deleteProfesionalResponse}
                modalOpened={modalEliminarProfesionalOpened}
                setModalOpened={setModalEliminarProfesionalOpened}
            />
            {
                puedeAvisarPorSms &&
                <ModalAvisoSmsProfesional
                    profesional={objProfesional}
                    modalOpened={modalAvisoSmsOpened}
                    setModalOpened={setModalAvisoSmsOpened}
                />
            }
            <YlmModalTwoButtons
                data={dataModal}
                setModalResponse={setModalPeriodoResponse}
                modalTwoButtonsOpened={modalTwoButtonsOpened}
                setModalTwoButtonsOpened={setModalTwoButtonsOpened}
            />
        </>
    )
}
